export default __webpack_public_path__ + "static/media/magon-2-room2-min.29ba090e.jpg";